import { createSlice/*, PayloadAction*/ } from "@reduxjs/toolkit";
import { RequestStatus } from "shared/constants";
import {IRequestState} from "dataModels/stateModels/request";

export const defaultState: IRequestState = {
    status: RequestStatus.PRISTINE
}

export const RequestStatusSlice = createSlice({
    name:"request",
    initialState:defaultState,
    reducers:{
        /*setRequestStatus(state:IRequestState, action:PayloadAction<IRequestAction>){
            state.state = action.payload.type
        },*/
        requestPending:(state:IRequestState)=>{
            state.status = RequestStatus.PENDING;
        },
        requestSuccess:(state:IRequestState)=>{
            state.status = RequestStatus.SUCCESS;
        },
        requestPristine:(state:IRequestState)=>{
            state.status = RequestStatus.PRISTINE;
        },
        requestError:(state:IRequestState)=>{
            state.status = RequestStatus.ERROR;
        }
    }
});
export const {requestSuccess, requestPending, requestError, requestPristine} = RequestStatusSlice.actions;
export default RequestStatusSlice.reducer;